// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1cN74","tab":"ProcedureTabs_tab__SksC5"};